import { getCountryFlagComponent } from '../components/Flags'
import { supportedLanguages } from './languages'

export const languageOptions = supportedLanguages.map((lang) => ({
  code: lang.code,
  label: (
    <div className="flex gap-2">
      {getCountryFlagComponent(lang.code)}
      <span>{lang.name}</span>
    </div>
  )
}))
